import {
  LEGALRUMIJA_LOADING,
  GET_LEGALRUMIJA,
  GET_LEGALRUMIJA_SUCCESS,
  GET_LEGALRUMIJA_FAIL,
  ADD_LEGALRUMIJA_SUCCESS,
  ADD_LEGALRUMIJA_FAIL,
  DELETE_LEGALRUMIJA_SUCCESS,
  DELETE_LEGALRUMIJA_FAIL,
  UPDATE_LEGALRUMIJA_SUCCESS,
  UPDATE_LEGALRUMIJA_FAIL,
  LEGALRUMIJA_RESET
} from "./actionType";

const INIT_STATE = {
  legalRumijas: [],
  error: {},
};

const LegalRumija = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LEGALRUMIJA_SUCCESS:
      switch (action.payload.actionType) {
        case GET_LEGALRUMIJA:
          return {
            ...state,
            legalRumijas: action.payload.data,
            isLegalRumijaCreated: false,
            isLegalRumijaSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_LEGALRUMIJA_FAIL:
      switch (action.payload.actionType) {
        case GET_LEGALRUMIJA_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isLegalRumijaCreated: false,
            isLegalRumijaSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_LEGALRUMIJA: {
      return {
        ...state,
        isLegalRumijaCreated: false,
        loading: true,
      };
    }

    case LEGALRUMIJA_LOADING: {
      return {
        ...state,
        isLegalRumijaCreated: false,
        loading: true,
      };
    }

    case ADD_LEGALRUMIJA_SUCCESS:
      return {
        ...state,
        isLegalRumijaCreated: true,
        loading: false,
        legalRumijas: [action.payload.data, ...state.legalRumijas],
      };

    case ADD_LEGALRUMIJA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_LEGALRUMIJA_SUCCESS:
      return {
        ...state,
        loading: false,
        legalRumijas: state.legalRumijas.filter(
          legalRumija => legalRumija.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_LEGALRUMIJA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_LEGALRUMIJA_SUCCESS:
      return {
        ...state,
        loading: false,
        legalRumijas: state.legalRumijas.map(legalRumija =>
          legalRumija.id.toString() === action.payload.data.id.toString() ? { ...legalRumija, ...action.payload.data } : legalRumija
        ),
      };

    case UPDATE_LEGALRUMIJA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case LEGALRUMIJA_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default LegalRumija;